<script lang="ts">
	import HotelDateRangePicker from '$lib/components/molecules/date/hotelDateRangePicker/HotelDateRangePicker.svelte';
	import { displayNumberOfNights } from '$lib/components/molecules/date/hotelDateRangePicker/utils';
	import { MAX_SELECTION_DAYS } from '$lib/components/pois/constants';
	import { transformStringDateToCalendarDate } from '$lib/utils/date';
	import * as m from '$paraglide/messages';
	import { CalendarDate, parseDate } from '@internationalized/date';

	interface Props {
		accommodationAvailabilityDateRange?: { startDate: string; endDate: string };
		name: string;
		id: string;
		onClearDates?: () => void;
		onOpen?: (inputId: string) => void;
		onSelectDates?: (datesRange: CalendarDate[]) => void;
	}

	const {
		accommodationAvailabilityDateRange,
		name,
		id,
		onOpen,
		onSelectDates,
		onClearDates,
	}: Props = $props();
</script>

<div class="flex flex-col items-start gap-2" {id}>
	<div class="text-coloredneutral pb-1 text-sm flex justify-between w-full">
		<span>{name}</span>
		<span class="text-bold">
			{#if accommodationAvailabilityDateRange?.startDate && accommodationAvailabilityDateRange?.endDate}
				{displayNumberOfNights(parseDate(accommodationAvailabilityDateRange?.startDate), parseDate(accommodationAvailabilityDateRange?.endDate))}
			{:else}
				{m.poi_filters__selected_items__none()}
			{/if}
		</span>
	</div>
	<HotelDateRangePicker
		maxSelectionDays={MAX_SELECTION_DAYS}
		shouldStayOpenAfterClearing
		{onOpen}
		{onSelectDates}
		{onClearDates}
		initialValues={{
			start: transformStringDateToCalendarDate(
				accommodationAvailabilityDateRange?.startDate,
			),
			end: transformStringDateToCalendarDate(
				accommodationAvailabilityDateRange?.endDate,
			),
		}}
	/>
</div>
